import { AuthError } from './AuthError.js';

class AuthWindowBlockedError extends AuthError {
    constructor(params) {
        const { message = 'Child window for authentication was blocked' } = params || {};
        super({ message });
    }
}

export { AuthWindowBlockedError };
//# sourceMappingURL=AuthWindowBlockedError.js.map
